
export enum LobbyAction {
    ClickedBotGame = 2,
    ClickedCreateRoom = 3,
    ClickedJoinRoom = 4,
    AccessGameLink = 5,
    ClickedSpectateGame = 6,
    ReconnectGame = 7,
    SaveClientReferrer = 8,
    SetAdBlockStatus = 9,
    InteractedWithSite = 10,
    ClickedStartBeginnerMode = 11,
    Clicked1v1BeginnerBotGame = 12,
    ClickedEasyBotGame = 13,
    WatchRoomList = 14,
    StopWatchingRoomList = 15,
    AutoRejoinGame = 16,
    ClickedStartShuffleBotGame = 17,
}

export const PRIMARY_LOBBY_ACTIONS: readonly LobbyAction[] = [
    LobbyAction.ClickedStartBeginnerMode,
    LobbyAction.ClickedBotGame,
    LobbyAction.Clicked1v1BeginnerBotGame,
    LobbyAction.ClickedCreateRoom,
    LobbyAction.ClickedJoinRoom,
    LobbyAction.AccessGameLink,
    LobbyAction.ClickedSpectateGame,
    LobbyAction.ReconnectGame,
    LobbyAction.ClickedStartShuffleBotGame,
]

export interface SendLobbyActionData {
    action: LobbyAction
    payload: unknown
}
